import * as tslib_1 from "tslib";
import store from '../store/store';
import { OptionsCheckbox, OptionDescription } from 'owa-options-controls';
import HelpLink from './HelpLink';
import strings from 'owa-strings/owa-options-strings';
import * as React from 'react';
import { reactive } from 'satcheljs/lib/legacy/react';
import { getUserConfiguration } from 'owa-session-store';
import { getFallbackValueIfNull } from 'owa-options-core';
import selectLinkPreviewIsEnabledOption from '../actions/selectLinkPreviewIsEnabledOption';
var LinkPreviewFull = /** @class */ (function (_super) {
    tslib_1.__extends(LinkPreviewFull, _super);
    function LinkPreviewFull() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LinkPreviewFull.prototype.render = function () {
        var _a = this.props, optionStore = _a.optionStore, userOptions = _a.userOptions;
        var isEnabled = getFallbackValueIfNull(optionStore.isEnabled, userOptions.LinkPreviewEnabled);
        return (React.createElement("div", null,
            React.createElement(OptionDescription, null,
                strings.options_mail_linkPreviewDescription,
                "\u00A0",
                React.createElement(HelpLink, { helpId: "LinkPreview" })),
            React.createElement(OptionsCheckbox, { checked: isEnabled, label: strings.options_mail_linkPreviewCheckboxLabel, onChange: this.toggleEnable })));
    };
    LinkPreviewFull.prototype.toggleEnable = function (ev, checked) {
        selectLinkPreviewIsEnabledOption(checked);
    };
    LinkPreviewFull = tslib_1.__decorate([
        reactive({
            optionStore: function () { return store; },
            userOptions: function () { return getUserConfiguration().UserOptions; },
        })
    ], LinkPreviewFull);
    return LinkPreviewFull;
}(React.Component));
export default LinkPreviewFull;
//# sourceMappingURL=LinkPreviewFull.js.map